import { createApiRequest } from "../common";
import { RemoveOrgMemberRequestContent } from '@equaliq/api-model-v2';

export const removeOrgMemberApi = async (request: RemoveOrgMemberRequestContent): Promise<void> => {
  const apiRequest = createApiRequest<void>('post', '/orgs/removeMember');
  return apiRequest(request);
};
